import React, { useEffect, useRef } from "react";
import PageTitle from "../components/pageTitle.js";

const LocationPage = () => {
  const mapRef = useRef(null);
  const centerLat = 37.7472333;
  const centerLng = 127.1192456;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=h81wnw69gd`;
    script.async = true;
    script.onload = () => {
      const center = new window.naver.maps.LatLng(centerLat, centerLng);
      const map = new window.naver.maps.Map(mapRef.current, {
        center: center,
        zoom: 16,
        zoomControl: false, // 기본 zoom 버튼 비활성화
      });
      map.setCenter(center);

      new window.naver.maps.Marker({
        position: center,
        map: map,
      });

      // 커스텀 줌 버튼 기능 연결
      const zoomInBtn = document.getElementById("zoom-in");
      const zoomOutBtn = document.getElementById("zoom-out");

      if (zoomInBtn && zoomOutBtn) {
        zoomInBtn.onclick = () => map.setZoom(map.getZoom() + 1);
        zoomOutBtn.onclick = () => map.setZoom(map.getZoom() - 1);
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
      <div>
        <PageTitle title="오시는길" />
      </div>

      <div style={{ position: "relative", marginBottom: "40px" }}>
        {/* 지도 */}
        <div
          ref={mapRef}
          style={{
            width: "100%",
            height: "400px",
            borderRadius: "8px",
            border: "1px solid #eee",
          }}></div>

        {/* + / - 줌 버튼 */}
        <div
          style={{
            position: "absolute",
            right: "10px",
            bottom: "20px",
            zIndex: 30,
          }}>
          <button id="zoom-in" style={zoomButtonStyle}>
            +
          </button>
          <button id="zoom-out" style={zoomButtonStyle}>
            −
          </button>
        </div>

        {/* ✅ 도움말 텍스트 */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "6px 10px",
            borderRadius: "4px",
            fontSize: "13px",
            color: "#444",
            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            zIndex: 30,
            fontWeight: "bold",
          }}>
          지도가 포커스되면 방향키로 이동할 수 있습니다
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: "10px",
        }}>
        <div style={{ color: "#666" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "5px",
            }}>
            아이엠플러스교육심리센터
          </div>
          <div style={{ color: "#98bcc9", fontSize: "25px" }}>
            경기도 의정부시 배꽃길 105.더리브센텀스퀘어 1동 9층 904호
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <a
            href="https://map.naver.com/v5/directions/-/14147564.928852385,4529956.944925289,아이엠플러스교육심리센터,1378305522,PLACE_POI/-/walk"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: "#98bcc9",
              padding: "10px 20px",
              borderRadius: "0px",
              textDecoration: "none",
              color: "white",
              fontWeight: "bold",
            }}
          >
            길찾기
          </a>
          <a
            href="https://map.naver.com/v5/search/경기도 의정부시 배꽃길 105 1동 9층 904호"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: "#98bcc9",
              padding: "10px 20px",
              borderRadius: "0px",
              textDecoration: "none",
              color: "white",
              fontWeight: "bold",
            }}>
            지도에서 보기
          </a>
        </div>
      </div>

      <div
        style={{ height: "1px", backgroundColor: "#eee", margin: "20px 0" }}
      />

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "20px",
          color: "#333",
        }}>
        <div className="flex items-start gap-2">
          <div className="text-[20px]">
            <img
              src="/images/cellphone-icon.png"
              alt="전화 아이콘"
              width={20}
              height={20}
            />
          </div>
          <div>
            <div className="font-bold mb-1">전화번호</div>

          </div>

          <div className="flex flex-col ml-14">
            <div>031-928-7329</div>
            <div>010-3251-7329</div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "20px",
          borderTop: "1px solid #eee",
          marginTop: "30px",
          paddingTop: "20px",
        }}
      >
        {/* 이용안내 텍스트 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontSize: "16px",
            color: "#444",
            minWidth: "100px",
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ fontSize: "18px" }}>
            <img
              src="/images/exclamation-icon.png"
              alt="느낌표 아이콘"
              width={20}
              height={20}
            />
          </span>
          이용안내
        </div>

        {/* 아이콘 목록 */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
            justifyContent: "flex-start",
            flex: "1",
          }}
        >
          {[
            {
              icon: (
                <img
                  src="/images/calendar-icon.png"
                  alt="예약 아이콘"
                  width={40}
                  height={40}
                />
              ),
              label: "예약",
            },
            {
              icon: (
                <img
                  src="/images/parkingcar-icon.png"
                  alt="주차 아이콘"
                  width={40}
                  height={40}
                />
              ),
              label: "주차",
            },
            {
              icon: (
                <img
                  src="/images/wirelessNetwork-icon.png"
                  alt="무선 아이콘"
                  width={40}
                  height={40}
                />
              ),
              label: "무선 인터넷",
            },
            {
              icon: (
                <img
                  src="/images/toilet-icon.png"
                  alt="화장실 아이콘"
                  width={40}
                  height={40}
                />
              ),
              label: "남/녀 화장실 구분",
            },
          ].map(({ icon, label }) => (
            <div
              key={label}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "100px",
              }}
            >
              <div style={{ marginBottom: "6px" }}>{icon}</div>
              <div style={{ fontSize: "14px", color: "#444" }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

// 공통 줌 버튼 스타일
const zoomButtonStyle = {
  display: "block",
  width: "40px",
  height: "40px",
  marginBottom: "5px",
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  fontSize: "20px",
  cursor: "pointer",
  borderRadius: "4px",
};

export default LocationPage;
